function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { App, message, Card, Divider, Button, Drawer, Modal, Skeleton, notification, Space } from 'antd';
import moment from 'moment';
import Common from './includes/Common';
import { Container, Row, Col } from 'react-bootstrap';
import { Pc, FilePlusFill, FolderFill, NodePlus, PencilSquare, ShareFill, TrashFill, LockFill, FileZipFill, InfoSquareFill } from 'react-bootstrap-icons';
import AddDocument from './forms/AddDocument';
import WorkbookInsideView from './WorkbookInsideView';
import EditWorkbook from './forms/EditWorkbook';
import AddWorkbookShare from './forms/AddWorkbookShare';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var WorkbooksView = function WorkbooksView(_ref) {
  var refresh = _ref.refresh;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataChanged = _useState2[0],
    setIsDataChanged = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewDocumentVisible = _useState6[0],
    setIsNewDocumentVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isWorkbookDetailsVisible = _useState8[0],
    setIsWorkbookDetailsVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isWorkbookEditVisible = _useState0[0],
    setIsWorkbookEditvisible = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isWorkbookShareVisible = _useState10[0],
    setIsWorkbookShareVisible = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentSelectedWb = _useState12[0],
    setCurrentSelectedWb = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    workbookList = _useState14[0],
    setWorkbookList = _useState14[1];
  var _useState15 = useState(moment().startOf('month').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    from = _useState16[0],
    setFrom = _useState16[1];
  var _useState17 = useState(moment().endOf('month').format()),
    _useState18 = _slicedToArray(_useState17, 2),
    to = _useState18[0],
    setTo = _useState18[1];
  var handleDelete = function handleDelete(workbook) {
    setCurrentSelectedWb(workbook);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "CONFIRMEZ-VOUS ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du classeur ", workbook.label, " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx(InfoSquareFill, {
          size: 18
        }), " ", /*#__PURE__*/_jsx("b", {
          children: "Les classeurs supprim\xE9s ne seront plus r\xE9cup\xE9rables"
        })]
      }),
      okText: "CONFIRMER",
      cancelText: "Annuler",
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'deleteworkbook', {
          user_id: Common.currentUser.id,
          workbook_id: workbook.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Opération réussie",
              description: "Le classeur à été supprimé"
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue pendant le traitement"
          });
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  var handleArchive = function handleArchive(workbook) {
    setCurrentSelectedWb(workbook);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "CONFIRMEZ-VOUS ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'archivage du classeur ", workbook.label, ". ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(InfoSquareFill, {
          size: 18
        }), " ", /*#__PURE__*/_jsxs("b", {
          children: ["Le classeur archiv\xE9 sera renomm\xE9 ARCHIVE-", workbook.label, " plac\xE9s dans un espace d\xE9di\xE9 aux archives"]
        })]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'archiveworkbook', {
          user_id: Common.currentUser.id,
          workbook_id: workbook.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Opération réussie",
              description: "Le classeur à été archivé avec succès"
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur",
            description: "Une erreur est survenue pendant le traitement"
          });
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    setIsDataChanged(false);
    axios.get("".concat(Common.baseApiUrl, "getuserworkbooks/").concat(Common.currentUser.id, "/").concat(Common.currentUser.id, "/").concat(from, "/").concat(to)).then(function (response) {
      if (response.data.status == 200) {
        setWorkbookList(response.data.workbooks);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged, refresh]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [workbookList.map(function (w) {
          return /*#__PURE__*/_jsxs(Col, {
            lg: 4,
            md: 4,
            sm: 6,
            children: [/*#__PURE__*/_jsxs(Card, {
              size: "middle",
              title: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Pc, {
                  style: {
                    color: w.color
                  },
                  size: 30
                }), w.label]
              }),
              extra: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: function onClick() {
                  setCurrentSelectedWb(w);
                  setIsNewDocumentVisible(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(NodePlus, {
                    size: 22
                  })
                })
              }),
              style: {
                width: '100%'
              },
              actions: [/*#__PURE__*/_jsx(Button, {
                onClick: function onClick() {
                  setCurrentSelectedWb(w);
                  setIsWorkbookDetailsVisible(true);
                },
                type: "link",
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(FolderFill, {
                    size: 18
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: function onClick() {
                  setCurrentSelectedWb(w);
                  setIsWorkbookEditvisible(true);
                },
                type: "link",
                children: /*#__PURE__*/_jsxs("b", {
                  children: [" ", /*#__PURE__*/_jsx(PencilSquare, {
                    size: 16
                  })]
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: function onClick() {
                  setCurrentSelectedWb(w);
                  setIsWorkbookShareVisible(true);
                },
                type: "link",
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(ShareFill, {
                    size: 16
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                disabled: w.documents.length == 0,
                onClick: function onClick() {
                  handleArchive(w);
                },
                type: "link",
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(FileZipFill, {
                    size: 16
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: function onClick() {
                  handleDelete(w);
                },
                type: "link",
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(TrashFill, {
                    size: 18
                  })
                })
              })],
              children: [/*#__PURE__*/_jsxs("p", {
                children: [w.description && w.description.substring(0, 56), " ..."]
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsxs("b", {
                  children: [w.documents.length, " Document(s)"]
                })
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    icon: /*#__PURE__*/_jsx(ShareFill, {
                      size: 13
                    }),
                    children: [" ", w.shares.length, " "]
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(LockFill, {
                    size: 13
                  }), " ", w.documents.filter(function (d) {
                    return d.secret == 1;
                  }).length, " Confidentiel(s)"]
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          }, w.id);
        }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
          active: true
        })]
      })
    }), currentSelectedWb != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["AJOUTER UN DOCUMENT DANS - ", currentSelectedWb.label]
        }),
        width: "90%",
        destroyOnClose: true,
        footer: null,
        open: isNewDocumentVisible,
        onCancel: function onCancel() {
          setIsNewDocumentVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddDocument, {
          handleUpdate: function handleUpdate() {
            setIsDataChanged(true);
          },
          workBook: currentSelectedWb,
          handleClose: function handleClose() {
            setIsNewDocumentVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["EXPLORATION DU CLASSEUR - ", currentSelectedWb.label]
        }),
        width: "98%",
        destroyOnClose: true,
        open: isWorkbookDetailsVisible,
        onClose: function onClose() {
          setIsWorkbookDetailsVisible(false);
        },
        children: /*#__PURE__*/_jsx(WorkbookInsideView, {
          workbook: currentSelectedWb
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["MODIFIER - ", currentSelectedWb.label]
        }),
        width: "400px",
        destroyOnClose: true,
        footer: null,
        open: isWorkbookEditVisible,
        onCancel: function onCancel() {
          setIsWorkbookEditvisible(false);
        },
        children: /*#__PURE__*/_jsx(EditWorkbook, {
          handler: function handler() {
            setIsDataChanged(true);
            notification.success({
              message: "Opération réussie",
              description: "Le classeur à été modifié avec succès"
            });
            setIsWorkbookEditvisible(false);
          },
          workbook: currentSelectedWb
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["PARTAGER - ", currentSelectedWb.label]
        }),
        width: "400px",
        destroyOnClose: true,
        footer: null,
        open: isWorkbookShareVisible,
        onCancel: function onCancel() {
          setIsWorkbookShareVisible(false);
        },
        children: /*#__PURE__*/_jsx(AddWorkbookShare, {
          handler: function handler() {
            setIsDataChanged(true);
            notification.success({
              message: "Opération réussie",
              description: "Le classeur à été partagé avec succès"
            });
            setIsWorkbookShareVisible(false);
          },
          workbook: currentSelectedWb
        })
      })]
    })]
  });
};
export default WorkbooksView;